import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import InputsAboutPerson from './components/AboutPerson';
import PopUpWrapper from './components/PopUpWrapper';
import CustomBtn from '../../generic/CustomBtn';
import { requestApi } from '../../utils/api-request';
import { appStore } from '../../state/app';

const RegisterNewFieldAgent = ({ showPopUp, setShowPopUp }) => {
  const { handleSubmit, register } = useForm();
  const { update } = useContext(appStore);
  const [resCreateFieldAgent, setResCreateFieldAgent] = useState('');
  const translate = useIntl();

  const createFieldAgent = async (data) => {
    const resultCreateFieldAgent = await requestApi('POST', '/api/dashboard/field-agent', { ...data });
    if (!resultCreateFieldAgent.message) {
      const requestFieldAgentsList = await requestApi('GET', '/api/dashboard/field-agent/list');
      update('app.allFa', requestFieldAgentsList);
      setShowPopUp(!showPopUp);
    } else {
      setResCreateFieldAgent(resultCreateFieldAgent.message);
    }
  };

  return (
    <PopUpWrapper showPopUp={showPopUp} setShowPopUp={setShowPopUp} widthParam="width-654">
      <h3 className="assign__caption">
        {translate.formatMessage({ id: 'popUp.fieldAgents.create' })}
      </h3>
      <form onSubmit={handleSubmit(createFieldAgent)}>
        <InputsAboutPerson
          register={register}
          resCreateFieldAgent={resCreateFieldAgent}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'button-create' })}
          customClass="assign__btn-accept"
          type="submit"
          handleClick={() => {}}
        />
      </form>
    </PopUpWrapper>
  );
};

export default RegisterNewFieldAgent;
